<template>
    <ModalBase @close="cancel" :withContent="true" :maxWidth="'default'">
        <main id="template-form" :class="{ loading }">
            <loader :loading="loading"></loader>
            <h1>{{ $t("plano.saveAsModal.saveAsLabel") }}</h1>
            <form>
                <label required for="name">{{ $t("template.form.name") }}</label>
                <input id="name" autofocus v-model="newTemplate.name" class="form-control" :class="{ error: error.name }" />

                <label required for="ref">{{ $t("template.form.ref") }}</label>
                <input id="ref" v-model="newTemplate.ref" class="form-control" :class="{ error: error.ref }" />
            </form>

            <footer class="txtCenter">
                <button class="btn" @click.prevent="saveNewTemplate">{{ $t("common.save") }}</button>
                <button class="btn" @click="cancel">{{ $t("common.cancel") }}</button>
            </footer>
        </main>
    </ModalBase>
</template>

<script>
import TryLoadMixin from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import ModalBase from "@/components/modal/ModalBase";
import displayer from "@/services/displayer";
import { save } from "plano_engine";

export default {
    data: () => ({
        newTemplate: {
            name: undefined,
            config: undefined,
            ref: undefined
        },
        error: {
            name: undefined,
            ref: undefined
        }
    }),
    props: {
        template: {
            type: Object,
            required: false
        }
    },
    components: { loader, ModalBase },
    mixins: [TryLoadMixin],
    methods: {
        async saveNewTemplate() {
            this.error.name = undefined;
            this.error.ref = undefined;
            if (!this.newTemplate.name) {
                this.error.name = true;
                return;
            }
            if (!this.newTemplate.ref) {
                this.error.ref = true;
                return;
            }
            this.newTemplate.config = save();
            const resp = await this.tryLoad(() => displayer.saveAs(this.template.id, this.newTemplate));
            this.dialogSuccess(this.$t("saved"));
            this.$emit("close");
            this.$router.push({ path: `/templates/${resp.id}` });
        },
        cancel() {
            this.$emit("close");
        }
    },
    created() {
        const { displayerTypeId, standDesignId, zoneIds, systemTypeId } = this.template;
        this.newTemplate = {
            ...this.newTemplate,
            standDesignId,
            displayerTypeId,
            zoneIds,
            systemTypeId
        };
    }
};
</script>

<style lang="scss" scoped>
main {
    position: relative;
    form {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-row-gap: 5px;
        grid-column-gap: 10px;
        padding: 20px 30px;

        > :not(:nth-child(2n)) {
            justify-self: end;
            align-self: center;
        }
    }
    // negate the loading indicator div
    &.loading > :not(:nth-child(2n + 1)) {
        justify-self: end;
    }

    label[required]::after {
        content: " *";
        font-weight: 800;
        color: red;
    }

    input {
        width: 100%;
        min-height: 40px;
        display: block;
        padding: 8px 40px 0 8px;
        border-radius: 5px;
        border: 1px solid #e8e8e8;
        &.error {
            border-color: red;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalSaveAsTemplate.vue?3ea2b9b8